export const SettingsTabs = {
  extends: 'TabsLinkSwitcher',
  children: (el) =>
    [
      el.isAdmin() && {
        href: '/project-account',
        text: el.getRootState('projectName')
      },
      el.isOwner() && {
        href: '/pricing',
        text: '{{ settings.tabs.billing | polyglot }}'
      },
      el.isEditMode() && {
        href: '/project-data',
        text: '{{ settings.tabs.data | polyglot }}'
      },
      {
        href: '/install',
        text: '{{ settings.tabs.install | polyglot }}'
      },
      el.isEditMode() && {
        href: '/project-versions',
        text: '{{ settings.tabs.versions | polyglot }}'
      },
      el.isAdmin() && {
        href: '/connect',
        text: '{{ settings.tabs.connect | polyglot }}'
      },
      el.isAdmin() && {
        href: '/shared-libs',
        text: '{{ settings.tabs.sharedLibraries | polyglot }}'
      },
      {
        href: '/settings',
        text: '{{ settings.tabs.settings | polyglot }}'
      }
    ].filter((v) => v),
  childrenAs: 'props',
  childProps: {
    isActive: (el, s) => s.key === el.href,
    borderStyle: 'solid',
    fontWeight: '400',
    padding: 'Z B1',
    '!isActive': {
      fontWeight: '400'
    },
    onClick: (ev, el, s) => {
      // el.call(
      //   'openModal',
      //   '/settings',
      //   {
      //     key: el.props.href
      //   },
      //   { forced: true }
      // )
      s.update({
        key: el.href
      })
    }
  }
}
